export enum StockQuantityBySupplierTypes {
    //Grid
    GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_LOADING = "@@stockqtyBySupplier/GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_LOADING",
    GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_SUCCESS = "@@stockqtyBySupplier/GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_SUCCESS",
    GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_ERROR = "@@stockqtyBySupplier/GET_STOCK_QUANTITY_BY_SUPPLIER_LIST_ERROR",
    
  GET_SUPPLIER_DROPDOWN_LOADING = "@@stockqtyBySupplier/GET_SUPPLIER_DROPDOWN_LOADING",
  GET_SUPPLIER_DROPDOWN_SUCCESS = "@@stockqtyBySupplier/GET_SUPPLIER_DROPDOWN_SUCCESS",
  GET_SUPPLIER_DROPDOWN_ERROR = "@@stockqtyBySupplier/GET_SUPPLIER_DROPDOWN_ERROR",
  }